import { Component, Inject, forwardRef } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ErrorMessages } from "../../common/constants";
import { AddTagDialogComponent } from "../../shared/component/tag-editor/add-tag-dialog.component";
import { HttpUtility } from "../../utility";
import { ErrorUtility } from "../../utility/error-utility";
import { DataImportWidgetService } from "./data-import-widget.service";

@Component({
    selector: 'data-import-add-dialog',
    template: require('./data-import-add-dialog.component.html'),
})
export class DataImportAddDialogComponent {

    error: string;
    csvLoaded: boolean;

    private csv: File;
    private fileInputs: any;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<AddTagDialogComponent>,
        @Inject(forwardRef(() => DataImportWidgetService)) private dataImportWidgetService: DataImportWidgetService,
        @Inject(forwardRef(() => HttpUtility)) private httpUtility: HttpUtility
    ) {
    }

    ngAfterViewChecked() {
        const opt = {
            buttonBefore: true,
            disabled: false,
            btnClass: "btn-default",
            dragdrop: false
        };
        this.fileInputs = $(':file') as any;
        this.fileInputs.filestyle(opt);
    }

    loadCsv(event) {
        const files: FileList = <any>(event.srcElement || event.target).files;
        if (files.length > 0) {
            this.csvLoaded = true;
            this.csv = files.item(0);
        } else {
            this.csvLoaded = false;
            this.csv = null;
        }
    }

    downloadExampleCsv(): void {
        const csvExample = `TIMESTAMP,<metric_name_1>,<metric_name_2>,<metric_name_n>`;
        let blob = new Blob([csvExample]);
        this.httpUtility.wrapFileAndDownload({ file: blob, fileName: "csvExample.csv" });
    }

    save(): void {
        const data = new FormData();
        data.set('file', this.csv, this.csv.name);
        this.dataImportWidgetService.performDataImport(data).then(_ => {
            this.dialogRef.close(true)
        }).catch(err => this.error = ErrorUtility.getMessage(err, ErrorMessages.GENERIC_ERROR));
    }

}